import * as Config from '../../config';
import Locale from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertCategories } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";


export class WaterLevel extends AlertLogic {
    static type = AlertType.WaterLevel;
    static category = AlertCategories.WATER_QUIALITY;
    static contentCategories = [ ContentCategories.WATER_LEVELING ];
    static title = Locale.gettext('Water Level');

    getInfo(timeZone?: string): AlertInfo {
        const alert = this.alert;
        const config = this.allConfigs;
        
        // Same for all alert types
        let { body, device, alertData, firstReported } = this.getCommons(timeZone);
        
        // Controller does not populate the body at the moment. Can be removed once Controller sets it.
        if (!alert.bodyUuid) {
            body = config?.Config?.BodiesOfWater?.find(body => body.UUID === device.HardwareDevice?.WaterLevelSensorSettings?.BodyOfWaterUUID);
        }

        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('Water Level'),
            cardDescription: this.locale.gettext('Water level in %1$s is %2$s.', 
                                    body?.Name, 
                                    alertData.SensorType === "HIGH" ? this.locale.gettext('high') : this.locale.gettext('low')
                                ),
            cardIllustration: 'report_error',
            detailIcon: 'water',
            detailDescription: this.locale.gettext('Water level in %1$s is %2$s.', 
                                    body?.Name, 
                                    alertData.SensorType === "HIGH" ? this.locale.gettext('high') : this.locale.gettext('low')),
            detailDescription2: this.locale.gettext('%1$s on %2$s port %3$s is reporting water %4$s.',
                                    device?.Name, 
                                    device.HardwareDevice?.WaterLevelSensorSettings?.WaterLevelSensor.Type.toLowerCase(),
                                    device.HardwareDevice?.WaterLevelSensorSettings?.WaterLevelSensor.Number,
                                    alertData.SensorType === "HIGH" ? this.locale.gettext('high') : this.locale.gettext('low')
                                ),
            detailDescription3: this.locale.gettext('Please inspect the sensor and plumbing for any issues!'),
            actionButtonTitle: false,
            resolveSummary: this.locale.gettext('%1$s water level back to normal', body?.Name)
        });
        alertInfo.contentCategories = WaterLevel.contentCategories;
        return alertInfo;
    }

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord[] {
        let device = config.Config.Devices.find(dev => dev.DeviceType === "WaterLevelSensor");
        let res = [];

        if (device) {
            res.push(
                new AlertRecord({
                    id: Math.floor(Math.random() * 100000),
                    uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "AHIGH" + type),
                    siteId: Math.floor(Math.random() * 100000),
                    deviceId: 1,
                    entityUuid: device?.UUID,
                    bodyUuid: config.Config.BodiesOfWater[0]?.UUID,
                    type: type,
                    data: {
                        SensorType: "HIGH"
                    }
                })
            );
            res.push(
                new AlertRecord({
                    id: Math.floor(Math.random() * 100000),
                    uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALOW" + type),
                    siteId: Math.floor(Math.random() * 100000),
                    deviceId: 1,
                    entityUuid: device?.UUID,
                    bodyUuid: config.Config.BodiesOfWater[0]?.UUID,
                    type: type,
                    data: {
                        SensorType: "LOW"
                    }
                })
            );
        }

        return res;
    }
}